// extracted by mini-css-extract-plugin
export default {"cls1":"PingAnswerStyles-cls1_Ene","cls2":"PingAnswerStyles-cls2__6k PingAnswerStyles-cls1_Ene"};